module.exports = __webpack_public_path__ + "img/filter-icon-blue.31b3df46.svg";